import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { GroupService } from '../../services/group.service';

@Component({
    selector: 'app-create-group',
    templateUrl: './create-group.component.html',
    styleUrls: ['./create-group.component.css', '../../app.component.css']
})

export class CreateGroupComponent implements OnInit {

    groupForm: FormGroup;
    group: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private groupService: GroupService) {
    }

    ngOnInit() {
        this.groupForm = this.formBuilder.group({
            name: ['', Validators.required],
            description: ['', Validators.required]
        });
    }

    onSubmitGroup() {
        this.group = this.saveGroup();

        const self = this;

        this.groupService.postGroup(this.group).then(resId => {
            if (resId !== '') {
                self.groupService.postPermissionAtomic(resId).then(function() {
                    self.groupForm.reset();
                    self.router.navigate(['/groups']);
                });
            }
        });
    }

    saveGroup() {
        const currentDate = new Date();

        const groupJson = {
            active: true,
            createdAt: currentDate,
            description: this.groupForm.get('description').value,
            name: this.groupForm.get('name').value,
            updatedAt: currentDate
        };

        return groupJson;
    }

}
